import React, { useState } from 'react';
import TypeEffectivenessQuiz from '../components/TypeEffectivenessQuiz';
import SpeedQuiz from '../components/quizzes/SpeedQuiz';
import BattleQuiz from '../components/quizzes/BattleQuiz';
import DamageCalcQuiz from '../components/quizzes/DamageCalcQuiz';
import { REGULATIONS } from '../data/regulations';
import './Quizzes.css';

const SPRITE_BASE = 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork';

const quizCards = [
  {
    id: 'type',
    title: 'Type Matchup Quiz',
    desc: 'Test your knowledge of Pokémon type effectiveness, including Terastallization!',
    pokemonId: 6,
    accentColor: '#FF7D54',
    label: 'Type Knowledge',
  },
  {
    id: 'speed',
    title: 'Speed Battle Quiz',
    desc: 'Compare Pokémon speeds with different items, abilities, and stat changes!',
    pokemonId: 135,
    accentColor: '#F8D030',
    label: 'Speed Comparison',
  },
  {
    id: 'battle',
    title: 'Battle Scenario Quiz',
    desc: 'Calculate damage multipliers in realistic battle scenarios with items, weather effects, and Terastallization!',
    pokemonId: 150,
    accentColor: '#FF6B7D',
    label: 'Battle Strategy',
  },
  {
    id: 'damage',
    title: 'Damage Calculator Quiz',
    desc: 'Predict damage ranges in battle scenarios with EVs, natures, items, weather, and terrain effects!',
    pokemonId: 445,
    accentColor: '#7038F8',
    label: 'Damage Calculation',
  },
];

function Quizzes() {
  const [isTypeQuizOpen, setIsTypeQuizOpen] = useState(false);
  const [isSpeedQuizOpen, setIsSpeedQuizOpen] = useState(false);
  const [isBattleQuizOpen, setIsBattleQuizOpen] = useState(false);
  const [isDamageCalcQuizOpen, setIsDamageCalcQuizOpen] = useState(false);
  const [regulation, setRegulation] = useState('all');

  const openHandlers = {
    type: () => setIsTypeQuizOpen(true),
    speed: () => setIsSpeedQuizOpen(true),
    battle: () => setIsBattleQuizOpen(true),
    damage: () => setIsDamageCalcQuizOpen(true),
  };

  return (
    <div className="quizzes-container">
      <div className="quizzes-header">
        <h1>Pokémon Battle Quizzes</h1>
        <p className="quizzes-subtitle">Test your competitive knowledge across four challenge types</p>
      </div>

      <div className="quiz-regulation-filter">
        <label htmlFor="regulation-select" className="quiz-regulation-label">Pokémon Pool:</label>
        <select
          id="regulation-select"
          className="quiz-regulation-select"
          value={regulation}
          onChange={(e) => setRegulation(e.target.value)}
        >
          {REGULATIONS.map(r => (
            <option key={r.value} value={r.value}>{r.label}</option>
          ))}
        </select>
      </div>

      <div className="quiz-navigation">
        {quizCards.map((card) => (
          <div
            key={card.id}
            className="quiz-card"
            onClick={openHandlers[card.id]}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && openHandlers[card.id]()}
          >
            <div className="quiz-card__banner" style={{ backgroundColor: card.accentColor }}>
              <img
                src={`${SPRITE_BASE}/${card.pokemonId}.png`}
                alt=""
                className="quiz-card__sprite"
                loading="lazy"
              />
            </div>
            <div className="quiz-card__body">
              <span className="quiz-card__label">{card.label}</span>
              <h2 className="quiz-card__title">{card.title}</h2>
              <p className="quiz-card__desc">{card.desc}</p>
              <div className="quiz-card__cta" style={{ color: card.accentColor }}>
                Start Quiz &rarr;
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="type-quiz-wrapper">
        <TypeEffectivenessQuiz isOpen={isTypeQuizOpen} onClose={() => setIsTypeQuizOpen(false)} />
      </div>
      <SpeedQuiz isOpen={isSpeedQuizOpen} onClose={() => setIsSpeedQuizOpen(false)} regulation={regulation} />
      <BattleQuiz isOpen={isBattleQuizOpen} onClose={() => setIsBattleQuizOpen(false)} regulation={regulation} />
      <DamageCalcQuiz isOpen={isDamageCalcQuizOpen} onClose={() => setIsDamageCalcQuizOpen(false)} regulation={regulation} />
    </div>
  );
}

export default Quizzes;
